export default __webpack_public_path__ + "static/media/beacon_hang_up_icon.6734f091.gif";